// extracted by mini-css-extract-plugin
export default {"Badge-ocean-primary":"theme-ocean_Badge-ocean-primary__goxfk","Badge-ocean-secondary":"theme-ocean_Badge-ocean-secondary__rHYfw"};